<div class="msi-switch-container">
    <div class="msi-switch">
        <input type="radio" class="msi-switch-input" name="toggle-btn" (click)="toggle.emit(false)" [checked]="!value" id="false-value"/>
        <label for="false-value" class="msi-switch-label msi-switch-label-off flex flex_centered justify_center">{{ textOff }}</label>
        <input type="radio" class="msi-switch-input" name="toggle-btn" (click)="toggle.emit(true)"  [checked]="value" id="true-value"/>
        <label for="true-value" class="msi-switch-label msi-switch-label-on flex flex_centered justify_center">{{ textOn }}</label>
        <span class="msi-switch-selection"></span>
    </div>

</div>